// extracted by mini-css-extract-plugin
module.exports = {"table":"LinkTable_table__1qvxB","cell":"LinkTable_cell__2WY29"};